export const keyboardEventCodePolyfill = {
  isNeeded: (): boolean => !("code" in KeyboardEvent.prototype),
  load: (/* locale: string */): Promise<void> =>
    import(
      /* webpackChunkName: "keyboardevent-key-polyfill" */
      "keyboardevent-key-polyfill"
    ).then(({ polyfill }) => polyfill()),
};
